import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'appHooks'
import {
  MeetingsListFilters,
  meetingsListInitialFilters,
} from 'shared/hooks/useMeetingsList'
import { STEERING_YEAR } from '../../constants/meetings'

const meetingsFiltersSlice = createSlice({
  name: 'meetingsFilters',
  initialState: meetingsListInitialFilters,
  reducers: {
    setMeetingsFilters: (_, action: PayloadAction<MeetingsListFilters>) =>
      action.payload,
    patchMeetingsFilters: (
      state,
      action: PayloadAction<Partial<MeetingsListFilters>>
    ) => ({ ...state, ...action.payload }),
    resetMeetingsFilters: () => meetingsListInitialFilters,
    resetMeetingsSearchFilters: (state) => ({
      ...state,
      to: undefined,
      from: undefined,
      searchText: '',
      take: meetingsListInitialFilters.take,
      skip: 0,
    }),
    resetMeetingsFilter: (state, action: PayloadAction<string>) => {
      if (action.payload === STEERING_YEAR)
        return { ...state, to: undefined, from: undefined }

      const field = action.payload as keyof MeetingsListFilters
      if (!state[field]) return state

      return { ...state, [field]: meetingsListInitialFilters[field] }
    },
  },
})

export const getMeetingsFilters = (state: RootState) => state.meetingsFilters

export const {
  setMeetingsFilters,
  patchMeetingsFilters,
  resetMeetingsFilters,
  resetMeetingsSearchFilters,
  resetMeetingsFilter,
} = meetingsFiltersSlice.actions

export default meetingsFiltersSlice
